document.addEventListener('alpine:init', () => {
  Alpine.data('ProductMp3Player', () => ({
    songs: [],
    currentName: '',
    progress: 0,
    audio: null,
    slider: null,
    _onTimeUpdate: null,
    _onLoadedMetadata: null,
    _onPlay: null,
    _onSliderInput: null,
    _onRadioPlay: null,
    _fadeRaf: null,

    init() {
      this.songs = JSON.parse(this.$refs.songs.textContent);

      if (!window.Amplitude || !this.songs.length) return;

      Amplitude.init({
        songs: this.songs,
      });

      this.slider = this.$refs.slider;
      this.audio = Amplitude.getAudio();

      this._onTimeUpdate = () => this.setProgress();
      this._onLoadedMetadata = () => {
        this.setProgress();
        this.setCurrentName();
      };
      this._onPlay = () => {
        this.setCurrentName();
        window.dispatchEvent(new CustomEvent('sv:mp3-play'));
      };
      this._onSliderInput = () => {
        if (!this.slider) return;
        this.progress = Number(this.slider.value) || 0;
      };
      this._onRadioPlay = () => this.fadeOutAndPause();

      if (this.audio) {
        this.audio.addEventListener('timeupdate', this._onTimeUpdate);
        this.audio.addEventListener('loadedmetadata', this._onLoadedMetadata);
        this.audio.addEventListener('play', this._onPlay);
      }

      if (this.slider) {
        this.slider.addEventListener('input', this._onSliderInput);
      }

      window.addEventListener('sv:radio-play', this._onRadioPlay);

      this.setProgress();
      this.setCurrentName();
    },

    destroy() {
      if (this._fadeRaf) cancelAnimationFrame(this._fadeRaf);
      if (window.Amplitude) Amplitude.pause();
      else if (this.audio) this.audio.pause();
      if (this._onRadioPlay) window.removeEventListener('sv:radio-play', this._onRadioPlay);

      if (this.audio) {
        this.audio.removeEventListener('timeupdate', this._onTimeUpdate);
        this.audio.removeEventListener('loadedmetadata', this._onLoadedMetadata);
        this.audio.removeEventListener('play', this._onPlay);
      }

      if (this.slider) {
        this.slider.removeEventListener('input', this._onSliderInput);
      }
    },

    fadeVolume(from, to, duration = 300) {
      return new Promise((resolve) => {
        if (!this.audio) {
          resolve();
          return;
        }

        if (this._fadeRaf) cancelAnimationFrame(this._fadeRaf);

        const start = performance.now();
        const step = (now) => {
          const t = Math.min(1, (now - start) / duration);
          this.audio.volume = from + (to - from) * t;
          if (t < 1) {
            this._fadeRaf = requestAnimationFrame(step);
          } else {
            this._fadeRaf = null;
            resolve();
          }
        };
        this._fadeRaf = requestAnimationFrame(step);
      });
    },

    async fadeOutAndPause() {
      if (!this.audio || this.audio.paused) return;
      await this.fadeVolume(this.audio.volume, 0);
      if (window.Amplitude) Amplitude.pause();
      this.audio.volume = 1;
      this.$el.querySelectorAll('.amplitude-play-pause').forEach((el) => {
        el.classList.remove('amplitude-playing');
        el.classList.add('amplitude-paused');
      });
    },

    setProgress() {
      this.progress =
        this.audio && this.audio.duration
          ? (this.audio.currentTime / this.audio.duration) * 100
          : 0;
    },

    setCurrentName() {
      const meta = Amplitude.getActiveSongMetadata();
      this.currentName = meta && meta.name ? meta.name : '';
    },
  }));
});
